// extracted by mini-css-extract-plugin
module.exports = {"school-pride-confetti__canvas":"school-pride-confetti_school-pride-confetti__canvas__35Sh9"};